module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACZJREFUeNpi+v//vxIQ3/0PATOBmIEBSHT8RwWhTAzYADbtAAEGAKvONeDDLR//AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/punkt_weiss.png
// module id = 171
// module chunks = 51